import ArticleUpdaterService from "@components/Article/ArticleUpdater/ArticleUpdaterService";
import ApiUrlCreatorService from "@core-ui/ContextServices/ApiUrlCreator";
import InfoModalForm from "@ext/errorHandlers/client/components/ErrorForm";
import type GetErrorComponent from "@ext/errorHandlers/logic/GetErrorComponent";
import BranchUpdaterService from "@ext/git/actions/Branch/BranchUpdaterService/logic/BranchUpdaterService";
import t from "@ext/localization/locale/translate";
import type { ComponentProps } from "react";

const BranchWasDeletedErrorComponent = ({ onCancelClick }: ComponentProps<typeof GetErrorComponent>) => {
	const apiUrlCreator = ApiUrlCreatorService.value;

	return (
		<InfoModalForm
			actionButton={{
				text: t("ok"),
				onClick: () => {
					BranchUpdaterService.updateBranch(apiUrlCreator);
					ArticleUpdaterService.update(apiUrlCreator);
					onCancelClick();
				},
			}}
			icon={{ code: "circle-x", color: "var(--color-danger)" }}
			title={t("git.branch.error.has-been-deleted.title")}
		>
			<p>{t("git.branch.error.has-been-deleted.body")}</p>
		</InfoModalForm>
	);
};

export default BranchWasDeletedErrorComponent;
